// Module
var code = "<div class=\"popover {{placement}} fade in\"> <div class=\"arrow\"></div> <div class=\"popover-inner\"> <h3 class=\"popover-title\" ng-bind=\"title\" ng-show=\"title\"></h3> <div class=\"popover-content\" bind-html-unsafe=\"content\"></div> </div> </div>";
// Exports
module.exports = code;